module.exports = __webpack_public_path__ + "img/ลูกค้าใหม่-05.01b40702.png";